module.exports = __webpack_public_path__ + "static/media/Ally_app_2.05c0bef7.jpg";